import { render, staticRenderFns } from "./UnsupportViewPcQrcode.vue?vue&type=template&id=3712c932&scoped=true&"
import script from "./UnsupportViewPcQrcode.vue?vue&type=script&lang=ts&"
export * from "./UnsupportViewPcQrcode.vue?vue&type=script&lang=ts&"
import style0 from "./UnsupportViewPcQrcode.vue?vue&type=style&index=0&id=3712c932&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3712c932",
  null
  
)

export default component.exports